/* Florescer — Combine e economize (tema Shopify), motor híbrido.
   Prioridade: regra comercial explícita → mesma habilidade → habilidade complementar → relacionados.
   Só itens de regra explícita comunicam condição especial. Nunca altera preço: o desconto
   automático da Shopify é quem aplica a condição no carrinho/checkout. */
(() => {
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const brl = (c) => (c / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  const promo = (c, d) => Math.round(c * (1 - (d || 0) / 100));
  const norm = (s) => String(s ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  const lista = (v) => (Array.isArray(v) ? v : v ? [v] : []).filter(Boolean);
  const minusc = (s) => s.charAt(0).toLowerCase() + s.slice(1);
  const juntar = (xs) => (xs.length > 1 ? `${xs.slice(0, -1).join(', ')} e ${xs[xs.length - 1]}` : xs[0] || '');
  const ALVO = 8;       // abaixo disso, a próxima camada completa a seleção
  const POR_GRUPO = 4;  // itens por camada: deixa espaço para a camada seguinte

  // Camadas 2–4 a partir do índice leve do catálogo (#fl-catalogo).
  function recomendar(dados, usados, totalInicial) {
    let catalogo = [];
    try { catalogo = JSON.parse(document.getElementById('fl-catalogo')?.textContent || '[]'); } catch {}
    const atual = catalogo.find((p) => String(p.id) === String(dados.produto.id));
    const habs = lista(atual?.habilidades?.length ? atual.habilidades : dados.produto.habilidades);
    const habN = habs.map(norm);
    const elegiveis = catalogo.filter((p) => p.disponivel !== false && !usados.has(String(p.id)) && (p.variantes || []).some((v) => v.disponivel))
      .map((p) => ({ ...p, variantes: p.variantes.filter((v) => v.disponivel).map((v) => ({ id: v.id, titulo: v.titulo, preco: v.preco })), imagemCard: p.imagem }));
    const grupos = []; let total = totalInicial;
    const pegar = (pontuar) => elegiveis.filter((p) => !usados.has(String(p.id))).map((p) => ({ p, n: pontuar(p) })).filter((x) => x.n > 0)
      .sort((a, b) => b.n - a.n || a.p.titulo.localeCompare(b.p.titulo, 'pt-BR')).slice(0, POR_GRUPO).map((x) => x.p);
    const incluir = (g) => { if (!g.produtos.length) return; g.produtos.forEach((p) => usados.add(String(p.id))); total += g.produtos.length; grupos.push(g); };
    const base = { desconto: 0, minimo: null, maximo: null };

    // 2) Mesma habilidade — mais habilidades em comum primeiro.
    if (total < ALVO && habN.length) {
      incluir({ ...base, id: 'mesma-habilidade', origem: 'habilidade', nome: 'Também trabalha habilidades parecidas',
        descricao: `Brinquedos que exploram também ${minusc(juntar(habs.slice(0, 2)))}.`,
        produtos: pegar((p) => lista(p.habilidades).map(norm).filter((h) => habN.includes(h)).length) });
    }
    // 3) Habilidade complementar — matriz central (metaobject complemento_de_habilidade).
    if (total < ALVO && habN.length && dados.matriz?.length) {
      const comp = new Map();
      dados.matriz.filter((m) => habN.includes(norm(m.habilidade))).forEach((m) => lista(m.complementares).forEach((c) => { if (!habN.includes(norm(c))) comp.set(norm(c), c); }));
      if (comp.size) {
        incluir({ ...base, id: 'habilidade-complementar', origem: 'complementar', nome: 'Outra forma de explorar',
          descricao: `Pode ampliar a brincadeira para ${minusc(juntar([...comp.values()].slice(0, 2)))}.`,
          produtos: pegar((p) => lista(p.habilidades).map(norm).filter((h) => comp.has(h)).length) });
      }
    }
    // 4) Relacionados — mesmos sinais do "Você também pode gostar".
    if (total < ALVO && atual) {
      const sinais = [...lista(atual.habilidades), ...lista(atual.objetivos), ...lista(atual.jeitos), atual.gesto, ...lista(atual.gestos)].filter(Boolean).map(norm);
      incluir({ ...base, id: 'relacionados', origem: 'relacionados', nome: 'Para continuar explorando', descricao: 'Outras ideias com jeitos de brincar parecidos.',
        produtos: pegar((p) => [...lista(p.habilidades), ...lista(p.objetivos), ...lista(p.jeitos), p.gesto, ...lista(p.gestos)].filter(Boolean).map(norm).filter((x) => sinais.includes(x)).length) });
    }
    return grupos;
  }

  function iniciar(root) {
    let dados;
    try { dados = JSON.parse(root.querySelector('[data-fl-combine-dados]').textContent); } catch { return; }
    const usados = new Set([String(dados.produto.id)]);
    // 1) Regra comercial explícita (prioridade; única camada com condição especial).
    const explicitos = (dados.grupos || []).map((g) => ({ ...g, produtos: g.produtos.filter((p) => p.variantes.length && !usados.has(String(p.id))) }))
      .filter((g) => g.produtos.length).sort((a, b) => a.ordem - b.ordem);
    explicitos.forEach((g) => g.produtos.forEach((p) => usados.add(String(p.id))));
    const grupos = [...explicitos, ...recomendar(dados, usados, explicitos.reduce((t, g) => t + g.produtos.length, 0))];
    if (!grupos.length) return;

    const comCondicao = explicitos.length > 0;
    const titulo = comCondicao ? 'Combine e economize' : 'Para deixar a brincadeira mais completa';
    root.querySelector('[data-fl-combine-titulo]').textContent = titulo;
    root.querySelector('[data-fl-combine-sub]').textContent = comCondicao ? 'Complementos com condição especial e outras ideias para brincar junto.' : 'Ideias que combinam com este brinquedo.';
    root.querySelector('[data-fl-combine-nota]').hidden = !comCondicao;

    const escolhas = {}; // produtoId -> { varianteId, quantidade, grupoId }
    const variantes = {};
    let grupoId = null, scrollY = 0, enviando = false;
    const selo = (g) => (g.desconto ? `${g.desconto}% off` : '');

    root.querySelector('[data-fl-combine-cards]').innerHTML = grupos.map((g) => `<div class="fl-combine__card">
      <div class="fl-combine__img">${g.produtos[0].imagemCard ? `<img src="${esc(g.produtos[0].imagemCard)}" alt="" loading="lazy" width="240" height="180">` : ''}</div>
      <div class="fl-combine__cardtxt"><p>${esc(g.nome)}</p><span${g.desconto ? '' : ' class="is-neutro"'}>${g.desconto ? selo(g) : `${g.produtos.length} ${g.produtos.length === 1 ? 'sugestão' : 'sugestões'}`}</span></div>
      <button type="button" class="fl-combine__ver" data-grupo="${esc(g.id)}" aria-label="Ver itens de ${esc(g.nome)}">Ver itens</button></div>`).join('');
    root.hidden = false;

    const modal = document.createElement('div');
    modal.className = 'fl-loja fl-cmodal'; modal.hidden = true;
    modal.innerHTML = `<div class="fl-cmodal__overlay" data-fechar></div>
      <div class="fl-cmodal__box" role="dialog" aria-modal="true" aria-labelledby="fl-cmodal-t">
        <button type="button" class="fl-cmodal__x" data-fechar aria-label="Fechar">×</button>
        <div class="fl-cmodal__head"><p class="fl-cmodal__eyebrow">${esc(titulo)}</p>
          <div class="fl-cmodal__trow"><h2 id="fl-cmodal-t" data-t></h2><span class="fl-cmodal__pct" data-pct></span></div>
          <p class="fl-cmodal__desc" data-desc></p>
          <div class="fl-cmodal__tabs" role="tablist" aria-label="Categorias de sugestões" data-tabs></div></div>
        <div class="fl-cmodal__body" data-body></div>
        <div class="fl-cmodal__foot">
          <div class="fl-cmodal__linha"><span data-qtd></span><span data-eco-linha>Economia <strong data-eco></strong></span></div>
          <div class="fl-cmodal__linha"><span>Total selecionado</span><span><s data-cheio></s> <strong class="fl-cmodal__total" data-promo></strong></span></div>
          <button type="button" class="fl-cmodal__cta" data-cta></button>
          <p class="fl-cmodal__erro" data-erro hidden></p>
        </div></div>`;
    document.body.appendChild(modal);
    const $ = (s) => modal.querySelector(s);

    const qtdGrupo = (id) => Object.values(escolhas).filter((e) => e.grupoId === id).reduce((t, e) => t + e.quantidade, 0);
    const linhas = () => Object.entries(escolhas).map(([pid, e]) => { const g = grupos.find((x) => x.id === e.grupoId); const p = g?.produtos.find((x) => String(x.id) === pid); const v = p?.variantes.find((x) => String(x.id) === String(e.varianteId)); return v ? { ...e, preco: v.preco, desconto: g.desconto || 0 } : null; }).filter(Boolean);

    function resumo() {
      const ls = linhas(); const q = ls.reduce((t, l) => t + l.quantidade, 0);
      const cheio = ls.reduce((t, l) => t + l.preco * l.quantidade, 0); const pr = ls.reduce((t, l) => t + promo(l.preco, l.desconto) * l.quantidade, 0);
      $('[data-qtd]').textContent = `${q} ${q === 1 ? 'item selecionado' : 'itens selecionados'}`;
      $('[data-eco-linha]').hidden = cheio - pr <= 0; $('[data-eco]').textContent = brl(cheio - pr);
      $('[data-cheio]').textContent = cheio - pr > 0 ? brl(cheio) : ''; $('[data-promo]').textContent = brl(pr);
      const cta = $('[data-cta]'); cta.disabled = !q || enviando;
      cta.textContent = enviando ? 'Adicionando…' : `Adicionar ${q || ''} ${q === 1 ? 'item' : 'itens'} ao carrinho`.replace('  ', ' ');
      return q;
    }

    function render() {
      const g = grupos.find((x) => x.id === grupoId); if (!g) return;
      $('[data-t]').textContent = g.nome; $('[data-pct]').textContent = selo(g);
      $('[data-desc]').textContent = g.desconto
        ? `${g.descricao || 'Condição aplicada pela Shopify no carrinho e no checkout.'}${g.maximo ? ` Até ${g.maximo} ${g.maximo === 1 ? 'item' : 'itens'} com condição.` : ''}`
        : g.descricao;
      $('[data-tabs]').innerHTML = grupos.map((x) => `<button type="button" role="tab" aria-selected="${x.id === grupoId}" data-tab="${esc(x.id)}">${esc(x.nome)}</button>`).join('');
      const limite = g.maximo != null && qtdGrupo(g.id) >= g.maximo;
      $('[data-body]').innerHTML = g.produtos.map((p) => {
        const e = escolhas[p.id]; const vid = variantes[p.id] ?? e?.varianteId ?? p.variantes[0].id; const v = p.variantes.find((x) => String(x.id) === String(vid)) || p.variantes[0];
        const tags = `${g.desconto ? `<span class="fl-cmodal__off">${g.desconto}% off</span>` : ''}${e ? '<span class="fl-cmodal__ok">✓ Selecionado</span>' : ''}`;
        return `<article class="fl-cmodal__item${e ? ' is-sel' : ''}">
          <div class="fl-cmodal__thumb">${p.imagem ? `<img src="${esc(p.imagem)}" alt="${esc(p.titulo)}" loading="lazy" width="240" height="240">` : ''}</div>
          <div class="fl-cmodal__info">${tags ? `<div class="fl-cmodal__tags">${tags}</div>` : ''}
            <h3>${esc(p.titulo)}</h3>
            <p class="fl-cmodal__precos">${g.desconto ? `<s>${brl(v.preco)}</s> <strong>${brl(promo(v.preco, g.desconto))}</strong>` : `<strong>${brl(v.preco)}</strong>`}</p>
            ${p.variantes.length > 1 ? `<label class="fl-cmodal__opc">Opção<select data-var="${p.id}" aria-label="Opção de ${esc(p.titulo)}">${p.variantes.map((x) => `<option value="${x.id}"${String(x.id) === String(v.id) ? ' selected' : ''}>${esc(x.titulo)}</option>`).join('')}</select></label>` : ''}
            <div class="fl-cmodal__acao">${e
              ? `<div class="fl-cmodal__qtd"><button type="button" data-menos="${p.id}" aria-label="Diminuir quantidade de ${esc(p.titulo)}">−</button><span>${e.quantidade}</span><button type="button" data-mais="${p.id}" aria-label="Aumentar quantidade de ${esc(p.titulo)}"${limite ? ' disabled' : ''}>+</button></div>`
              : `<button type="button" class="fl-cmodal__add" data-add="${p.id}" data-v="${v.id}"${limite ? ' disabled' : ''}>+ Adicionar</button>`}</div></div></article>`;
      }).join('');
      resumo();
    }

    function abrir(id) {
      scrollY = window.scrollY; grupoId = id; modal.hidden = false;
      document.documentElement.classList.add('fl-lock'); render(); $('.fl-cmodal__x').focus();
    }
    function fechar() {
      modal.hidden = true; grupoId = null; document.documentElement.classList.remove('fl-lock');
      requestAnimationFrame(() => window.scrollTo({ top: scrollY }));
    }

    root.addEventListener('click', (ev) => { const b = ev.target.closest('[data-grupo]'); if (b) abrir(b.dataset.grupo); });
    modal.addEventListener('click', (ev) => {
      const t = ev.target;
      if (t.closest('[data-fechar]')) return fechar();
      const tab = t.closest('[data-tab]'); if (tab) { grupoId = tab.dataset.tab; $('[data-body]').scrollTop = 0; return render(); }
      const add = t.closest('[data-add]'); if (add) { escolhas[add.dataset.add] = { varianteId: add.dataset.v, quantidade: 1, grupoId }; return render(); }
      const mais = t.closest('[data-mais]'); if (mais) { escolhas[mais.dataset.mais].quantidade++; return render(); }
      const menos = t.closest('[data-menos]'); if (menos) { const e = escolhas[menos.dataset.menos]; if (e.quantidade <= 1) delete escolhas[menos.dataset.menos]; else e.quantidade--; return render(); }
      if (t.closest('[data-cta]')) confirmar();
    });
    modal.addEventListener('change', (ev) => { const s = ev.target.closest('[data-var]'); if (!s) return; variantes[s.dataset.var] = s.value; if (escolhas[s.dataset.var]) escolhas[s.dataset.var].varianteId = s.value; render(); });
    document.addEventListener('keydown', (ev) => { if (ev.key === 'Escape' && !modal.hidden) fechar(); });

    async function confirmar() {
      const ls = linhas(); const q = ls.reduce((t, l) => t + l.quantidade, 0); if (!q || enviando) return;
      enviando = true; $('[data-erro]').hidden = true; resumo();
      try {
        // Uma única chamada: todos os itens entram juntos no carrinho nativo atual, com preço real.
        const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: ls.map((l) => ({ id: Number(l.varianteId), quantity: l.quantidade })) }) });
        if (!r.ok) { const e = await r.json().catch(() => ({})); throw new Error(e.description || 'Não foi possível adicionar.'); }
        if (window.FlorescerCarrinho) await window.FlorescerCarrinho.buscar();
        Object.keys(escolhas).forEach((k) => delete escolhas[k]);
        const st = root.querySelector('[data-fl-combine-status]'); st.textContent = `${q} ${q === 1 ? 'item adicionado' : 'itens adicionados'} ao carrinho.`; st.hidden = false;
        enviando = false; fechar();
      } catch (e) {
        enviando = false; const er = $('[data-erro]'); er.textContent = e.message; er.hidden = false; resumo();
      }
    }
  }

  const go = () => document.querySelectorAll('[data-fl-combine]').forEach(iniciar);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();
